import React, { useState, useEffect } from "react";
import { getdata } from "../services/apicall.tsx";
import { useUserContext, Statescontex } from "../context";

const Datafetcher = () => {
  const [loading, setloading] = useState(false);
  const { userToken, userdetails, isloggedin } = useUserContext();
  const { setErrorMessage, setErrorshow, setlive } = Statescontex();
  const t = userToken;

  function shouldRunScript() {
    const now = new Date();
    const options = {
      timeZone: "Asia/Kolkata",
      hour12: false,
      hour: "numeric",
    };
    const hours = parseInt(new Intl.DateTimeFormat("en-US", options).format(now), 10);
    return hours >= 9 && hours < 16;
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        setloading(true);
        if (
          userdetails?.isverified === true &&
          isloggedin &&
          userToken &&
          userToken !== "loggedout" &&
          userToken !== "Expired"
        ) {
          await getdata(t, setloading, setlive, setErrorMessage, setErrorshow);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setErrorMessage("h_Failed to fetch data");
        setErrorshow(true);
      } finally {
        setloading(false);
      }
    };

    fetchData();
    const intervalId = setInterval(() => {
      if (shouldRunScript()) {
        fetchData();
      }
    }, 10000); // Fetch every 10 seconds

    return () => clearInterval(intervalId); // ✅ Proper cleanup
  }, [userdetails?.isverified, userToken, isloggedin]);

  return null; // ✅ Makes intent clear: background-only component
};

export default Datafetcher;
